const Contact = () => {
  return (
    <div className="page-container">
      <div className="page-content">
        <div className="hero-section">
          <h1>Contact Us</h1>
        </div>
        <div className="contact-content"></div>
        <div className="contact-content">
          <div className="contact-info">
            <div className="contact-block">
              <h3>Let's Collaborate</h3>
              <p>
                Whether you're a researcher with a groundbreaking idea, a healthcare 
                organization facing complex challenges, or a patient advocate looking 
                for innovative solutions, we want to hear from you.
              </p>
            </div>

            <div className="contact-block">
              <h3>What We're Looking For</h3>
              <ul>
                <li>Challenging healthcare problems that need innovative solutions</li>
                <li>Research partnerships across disciplines</li>
                <li>Patient organizations serving underrepresented communities</li>
                <li>Healthcare systems ready to embrace change</li>
                <li>Investors who share our mission to reduce suffering</li>
              </ul>
            </div>
          </div>

          <div className="contact-form-container">
            <div className="contact-block">
              <h3>Get in Touch</h3>
              <p>
                We're excited to connect with you! Please reach out to us directly via email or phone:
              </p>
              <ul>
                <li>
                  <strong>Email:</strong> <a href="mailto:info@blacksheepdev.io" style={{ color: '#3498db' }}>info@blacksheepdev.io</a>
                </li>
              </ul>
              <p>
                We'll respond as soon as possible. Thank you for your interest!
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;